<div id="hooverPopup" [ngStyle]="{'visibility': popupVisibility}" class="hooverPopupDiv popup {{additionalClasses}}" [ngClass]="{'isMobileCoapp': isCoapp && isMobile}" [innerHTML]="text">
</div>
